import { formatDurationRange } from '../../../../../utils/taskDuration';

/**
 * Text for the clickable remaining-time segment (excludes completion/progress parts).
 */
export function buildRemainingTimeLabel({
  remainingMinutes = 0,
  remainingMinMinutes,
  missingEstCount = 0,
}) {
  const maxMinutes = remainingMinutes || 0;
  const minMinutes = remainingMinMinutes == null ? maxMinutes : remainingMinMinutes;
  const timeStr = formatDurationRange(minMinutes, maxMinutes);

  let label = `${timeStr} remaining`;

  if (missingEstCount > 0) {
    const taskLabel = missingEstCount === 1 ? 'task' : 'tasks';
    label += ` (${missingEstCount} ${taskLabel} without est. time)`;
  }

  return label;
}

/**
 * Build the "X / Y complete • … remaining" line used in campaign headers.
 */
export function buildCampaignStatsText({
  completedCount,
  totalCount,
  remainingMinutes = 0,
  remainingMinMinutes,
  missingEstCount = 0,
  progressPercent,
  includeProgressPercent = false,
}) {
  const parts = [`${completedCount} / ${totalCount} complete`];

  if (includeProgressPercent && progressPercent != null) {
    parts.push(`${progressPercent}%`);
  }

  const hasIncompleteWork = completedCount < totalCount;
  if (hasIncompleteWork) {
    parts.push(buildRemainingTimeLabel({ remainingMinutes, remainingMinMinutes, missingEstCount }));
  }

  return parts.join(' • ');
}
